import { autoinject, LogManager } from 'aurelia-framework';
import { Endpoint, Rest, Config } from 'aurelia-api';
import 'whatwg-fetch';
import { DirectoryInfo } from 'data/entities/directory-info';
import { AuthService } from 'aurelia-authentication';
import { AccountService } from './account-service';

@autoinject(Config)
export class DirectoryService {

	logger = LogManager.getLogger('DirectoryService');

	async setDefaultDirectory(appUserId: string) {
		try {
			await this.apiEndpoint.post(`directoryinfo/${appUserId}`);
			const response = await this.authService.updateToken();
			this.accountService.setAuthResponse(this.authService.getIdToken());//Update the token used by the FetchClient. Otherwise, will use the old.
		}
		catch (exception) {
			this.logger.error("setDefaultDirectory() failed.");
		}
	}

	apiEndpoint: Rest;
	constructor(private config:Config, private accountService:AccountService, private authService:AuthService) {
		this.apiEndpoint = config.getEndpoint('auth');	
	}

	listAsync() : Promise<Array<DirectoryInfo>> {
		return this.apiEndpoint.find("directoryinfo");
	}
	
}